const normalizedItemIds = (itemIds: readonly string[]): string[] =>
  Array.from(new Set(itemIds.map((itemId) => itemId.trim()).filter(Boolean))).sort()

export const hasSamePrintSelection = (
  left: readonly string[],
  right: readonly string[],
): boolean => {
  const normalizedLeft = normalizedItemIds(left)
  const normalizedRight = normalizedItemIds(right)

  return (
    normalizedLeft.length === normalizedRight.length &&
    normalizedLeft.every((itemId, index) => itemId === normalizedRight[index])
  )
}
